import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import {
  imgPasswordInVisible,
  imgPasswordVisible,
  signupGroupSmallImg,
} from "./assets";
import React, { createRef } from "react";
import { Typography, TypographyProps, styled } from "@mui/material";
import { FormikErrors, FormikProps } from "formik";
import { getStorageData } from "../../../framework/src/Utilities";
import { logEvent } from "../../../components/src/utils/googleAnalytics/analyticsAdapter.web";

export const TypographyView: React.FC<TypographyProps> = styled(Typography)({
  "& *": {
    fontFamily: "Montserrat !important",
    fontWeight: "400",
  },
  "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button":
    {
      WebkitAppearance: "none",
      margin: 0,
    },
  "& .signupContainer": {
    width: "100%",
    display: "flex",
    backgroundColor: "#EFF6FF",
  },
  "& .signupLeftCon": {
    position: "relative",
    width: "calc(100% - 30%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "0",
    zIndex: "10",
    "@media (max-width: 767px)": {
      width: "100%",
      backgroundImage: `url(${signupGroupSmallImg})`,
      backgroundSize: "100% 100%",
      backgroundRepeat: "repeat",
      "&::before": {
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        backgroundColor: "#0F172A",
        opacity: "0.4",
      },
    },
  },
  "& .signupLeftConInsideCard": {
    position: "relative",
    backgroundColor: "#FFFFFF",
    borderRadius: "20px",
    margin: "30px auto",
    padding: "42px 56px",
    "@media (max-width: 767px)": {
      margin: "12px",
      padding: "30px",
    },
    "@media (min-width: 768px) and (max-width: 1023px)": {
      margin: "15px",
      padding: "35px",
    },
  },
  "& .signupLeftCon h4": {
    fontSize: "28px",
    fontWeight: "600",
    lineHeight: "32px",
    color: "#0F172A",
    marginBottom: "17.5px",
    letterSpacing: "-0.12px",
    "@media (max-width: 414px)": {
      fontSize: "24px",
      lineHeight: "28px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "26px",
      lineHeight: "30px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "30px",
      lineHeight: "34px",
    },
  },
  "& .signupFormCon": {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    "@media (max-width: 425px)": {
      gap: "15px",
    },
  },
  "& .mainTitleText": {
    fontSize: "28px",
    fontWeight: 600,
    lineHeight: "32px",
    color: "#0F172A",
    letterSpacing: "-0.12px",
    marginBottom: "17.5px",
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "24px",
      lineHeight: "29px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "24px",
      lineHeight: "29px",
    },
  },
  "& .subTitle": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "19.5px",
    color: "#64748B",
    letterSpacing: "0%",
    marginBottom: "15.5px",
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "16px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "20px",
    },
  },
  "& .labelWrapper": {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "#0F172A !important",
    marginBottom: "4px",
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 400,
    },
  },
  "& .custom-password input": {
    webkitTextSecurity: "*",
  },
  "& .input": {
    marginTop: "4px",
    "& div": {
      borderRadius: "32px",
      borderColor: "#CBD5E1",
    },
    "& input": {
      fontSize: "16px",
      lineHeight: "24px",
      color: "#64748b !important",
      fontWeight: "400",
      padding: "16px 24px 16px 24px",
      "@media (max-width: 414px)": {
        lineHeight: "20px",
      },
      "@media (min-width: 415px) and (max-width: 1280px)": {
        lineHeight: "22px",
      },
      "@media (min-width: 1600px)": {
        fontSize: "18px",
        lineHeight: "26px",
      },
    },
    "& input::placeholder": {
      fontSize: "16px",
      lineHeight: "24px",
      color: "#64748b !important",
      opacity: "1 !important",
      "@media (max-width: 414px)": {
        fontSize: "15px",
        lineHeight: "20px",
      },
      "@media (min-width: 415px) and (max-width: 1280px)": {
        fontSize: "15px",
        lineHeight: "22px",
      },
      "@media (min-width: 1600px)": {
        fontSize: "18px",
        lineHeight: "26px",
      },
    },
  },
  "& .phoneNumber": {
    "& input": {
      padding: "16px 0",
    },
  },
  "& .menuItem, & .verifyText": {
    fontSize: "16px",
    lineHeight: "22px",
    fontWeight: "500",
    color: "#64748B !important",
    cursor: "pointer",
    "@media (max-width: 414px)": {
      fontSize: "13px",
      lineHeight: "16px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "14px",
      lineHeight: "18px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "24px",
    },
  },
  "& .css-1wc848c-MuiFormHelperText-root.Mui-error, & .errorText, & .validationsChecks, & .css-1wc848c-MuiFormHelperText-root.Mui-error":
    {
      fontSize: "12px !important",
      lineHeight: "22px !important",
      color: "#E11B23 !important",
    },
  "& .verifyText": {
    backgroundColor: "transparent",
    padding: "0",
    border: "none",
    outline: "none",
    color: "#E11B23 !important",
  },
  "& .verifiedText": {
    color: "#409046 !important",
  },
  "& .validationsChecks": {
    gap: "6px",
    color: "#0F172A !important",
    padding: "0",
    "& div": {
      minWidth: "auto",
    },
    "& svg": {
      width: "14px",
      height: "14px",
    },
  },
  "& .countryCode": {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#64748B",
    padding: "0 8px 0 10px",
    margin: "0",
    "@media (max-width: 414px)": {
      lineHeight: "20px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      lineHeight: "22px",
    },
    "@media (min-width: 1600px)": {
      fontSize: "18px",
      lineHeight: "26px",
    },
  },
  "& .agreeText": {
    fontSize: "14px",
    lineHeight: "24px",
    fontWeight: "500",
    color: "#652784 !important",
    "@media (max-width: 414px)": {
      lineHeight: "20px",
    },
    "@media (min-width: 415px) and (max-width: 1280px)": {
      fontSize: "12px",
      lineHeight: "22px",
      "&:button": {
        fontSize: "12px",
      },
    },
    "@media (min-width: 1600px)": {
      fontSize: "16px",
      lineHeight: "26px",
      "&:button": {
        fontSize: "16px",
      },
    },
    "& button": {
      fontWeight: "700",
      fontSize: "14px",
      textTransform: "none",
      backgroundColor: "transparent",
      padding: "0px",
      textDecoration: "underline",
      border: "none",
      paddingLeft: "4px",
      color: "#652784 !important",
      textDecorationColor: "currentColor",
    },
  },
  "& .signupBtn": {
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    color: "#FFFFFF",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    textTransform: "none",
    borderRadius: "30px",
    padding: "16px 0",
    maxWidth: "360px",
    "&.Mui-disabled": {
      color: "#FFFFFF",
      opacity: 0.25,
    },
  },
  "& .signupOrText": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    "& div": {
      borderBottom: "1px solid #CBD5E1",
      width: "100%",
      maxWidth: "140px",
    },
    "& span": {
      fontSize: "14px",
      lineHeight: "24px",
      fontWeight: "500",
      color: "#64748B !important",
    },
  },
  "& .signupAlreadyAccCon": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    "& p": {
      color: "#64748B !important",
      margin: "0",
    },
    "& button": {
      color: "#652784 !important",
      padding: "0",
      minWidth: "auto",
    },
    "& p, & button": {
      fontSize: "16px",
      lineHeight: "22px",
      fontWeight: "500",
      textTransform: "initial",
      "@media (max-width: 414px)": {
        fontSize: "14px",
        lineHeight: "18px",
      },
      "@media (min-width: 415px) and (max-width: 1280px)": {
        fontSize: "14px",
        lineHeight: "20px",
      },
      "@media (min-width: 1600px)": {
        fontSize: "18px",
        lineHeight: "24px",
      },
    },
  },
  "& .signupRightCon": {
    "@media (max-width: 767px)": {
      "& img": {
        display: "none",
      },
    },
    "@media (min-width: 768px)": {
      width: "30%",
      overflow: "hidden",
      "& img": {
        width: "100%",
        height: "100%",
      },
    },
  },
});

export const webStyle = {
  modalContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modalTitle: {
    fontSize: "28px",
    fontWeight: "600",
    lineHeight: "32px",
    color: "#0F172A",
    marginBottom: "15px",
    fontFamily: "Montserrat, sans-serif !important",
  },
  modalDesc: {
    width: "318px",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "22px",
    color: "#64748B",
    textAlign: "center",
    marginBottom: "10px",
    fontFamily: "Montserrat, sans-serif !important",
    "@media (max-width: 425px)": {
      width: "100%",
    },
  },
  modalInput: {
    marginBottom: "5px",
    "& div": {
      height: "65px",
      width: "65px",
      border: "1px solid #CBD5E1",
      borderRadius: "16px",
      "@media (max-width: 425px)": {
        height: "50px",
        width: "50px",
      },
    },
    "& input": {
      fontSize: "24px",
      fontWeight: "500",
      lineHeight: "32px",
      color: "#0F172A",
      textAlign: "center",
      fontFamily: "Montserrat, sans-serif !important",
    },
  },
  closeIcon: {
    p: 0,
    "& svg": {
      fontSize: "24px",
      fill: "#000",
    },
  },
  modalSubmitBtn: {
    fontSize: "16px !important",
    fontWeight: "600",
    width: "290px !important",
    height: "56px !important",
    color: "#fff !important",
    lineHeight: "24px !important",
    border: "1px solid currentColor",
    borderRadius: "30px",
    padding: "10px 16px !important",
    cursor: "pointer",
    background: "linear-gradient(90deg, #8077FF 0%, #652784 60%)",
    textTransform: "initial",
    marginBottom: "20px",
    fontFamily: "Montserrat, sans-serif !important",
    "@media (max-width: 425px)": {
      width: "250px !important",
    },
  },
  modalResendOtpBtn: {
    fontSize: "16px",
    fontWeight: "500",
    lineHeight: "22px",
    color: "#652784",
    textTransform: "initial",
    fontFamily: "Montserrat, sans-serif !important",
  },
};

export const requirementsForPass = [
  { label: "At least one capital letter (A-Z)", regex: /[A-Z]/ },
  { label: "At least one lowercase letter (a-z)", regex: /[a-z]/ },
  { label: "At least one special character", regex: /[!@#$%^&*]/ },
];

export const requirementsForConfirmPass = [
  { label: "At least one number (0-9)", regex: /[0-9]/ },
  { label: "Minimum length is 8 character", regex: /.{8,}/ },
];

interface IPhoneVerificationValues {
  phone_number: string;
  pin: string;
}

interface IPhoneVerificationSuccessResponse {
  message: string;
}

interface IPhoneVerificationErrorResponse {
  error: string;
}

interface IEmailVerificationSuccessResponse {
  message: string;
}

interface IEmailVerificationErrorResponse {
  errors: {
    [key: string]: string;
  }[];
}

interface ISignUpValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  role: string;
  agreeToTerms: boolean;
}

interface ISignUpPayload {
  first_name: string;
  last_name: string;
  full_phone_number: string;
  email: string;
  terms_accepted: boolean;
  password: string;
  password_confirmation: string;
}

interface ISignUpSuccessResponse {
  message: string;
}

interface ISignUpErrorsResponse {
  errors: {
    [key: string]: string;
  }[];
}

interface ISignUpErrorResponse {
  error: string;
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

export interface S {
  // Customizable Area Start
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  otpAuthToken: string;
  reTypePassword: string;
  data: any[];
  passwordHelperText: string;
  enablePasswordField: boolean;
  enableReTypePasswordField: boolean;
  countryCodeSelected: string;
  phone: string;
  rePasswordMatchError: boolean;
  passwordsAreIdentical: boolean;
  triggerModal: boolean;
  verifyPhoneOtp: any[];
  isLoading: boolean;
  isAccountDetailsFilled: boolean;
  isVerifyingPhone: boolean;
  isPhoneVerified: boolean;
  otpError: string;
  createdAccountEmail: string;
  isResendEmailDialog: boolean;
  resendEmailInfoType: "success" | "error";
  resendEmailMessage: string;
  apiError: string;
  // Customizable Area End
}

export interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class EmailAccountRegistrationController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  arrayholder: any[];
  passwordReg: RegExp;
  emailReg: RegExp;
  createAccountApiCallId: any;
  validationApiCallId: string = "";

  imgPasswordVisible: any;
  imgPasswordInVisible: any;

  labelHeader: any;
  labelFirstName: string;
  lastName: string;
  labelEmail: string;
  labelPassword: string;
  labelRePassword: string;
  labelLegalText: string;
  labelLegalTermCondition: string;
  labelLegalPrivacyPolicy: string;
  btnTextSignUp: string;

  currentCountryCode: any;
  inputRefs: React.RefObject<HTMLInputElement>[];

  createUserAccountApiCallId: string = "";
  sendPhoneOtpApiCallId: string = "";
  verifyPhoneOtpApiCallId: string = "";
  emailVerificationLinkApiCallId: string = "";
  formikRef = createRef<FormikProps<ISignUpValues>>();
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.CountryCodeMessage),
    ];
    this.receive = this.receive.bind(this);
    this.isStringNullOrBlank = this.isStringNullOrBlank.bind(this);

    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    this.state = {
      // Customizable Area Start
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      reTypePassword: "",
      otpAuthToken: "",
      data: [],
      passwordHelperText: "",
      enablePasswordField: true,
      enableReTypePasswordField: true,
      countryCodeSelected: "",
      phone: "",
      rePasswordMatchError: false,
      passwordsAreIdentical: false,
      triggerModal: false,
      verifyPhoneOtp: ["", "", "", ""],
      isLoading: false,
      isAccountDetailsFilled: false,
      isPhoneVerified: false,
      isVerifyingPhone: false,
      otpError: "",
      createdAccountEmail: "",
      isResendEmailDialog: false,
      resendEmailInfoType: "success",
      resendEmailMessage: "",
      apiError: "",
      // Customizable Area End
    };

    // Customizable Area Start
    this.arrayholder = [];
    this.passwordReg = new RegExp("\\w+");
    this.emailReg = new RegExp("\\w+");

    this.imgPasswordVisible = imgPasswordVisible;
    this.imgPasswordInVisible = imgPasswordInVisible;

    this.labelHeader = configJSON.labelHeader;
    this.labelFirstName = configJSON.labelFirstName;
    this.lastName = configJSON.lastName;
    this.labelEmail = configJSON.labelEmail;
    this.labelPassword = configJSON.labelPassword;
    this.labelRePassword = configJSON.labelRePassword;
    this.labelLegalText = configJSON.labelLegalText;
    this.labelLegalTermCondition = configJSON.labelLegalTermCondition;
    this.labelLegalPrivacyPolicy = configJSON.labelLegalPrivacyPolicy;
    this.btnTextSignUp = configJSON.btnTextSignUp;
    this.inputRefs = Array(4)
      .fill(null)
      .map(() => createRef<HTMLInputElement>());
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      var responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      var errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (apiRequestCallId && responseJson) {
        if (apiRequestCallId === this.validationApiCallId) {
          this.arrayholder = responseJson.data;

          if (this.arrayholder && this.arrayholder.length !== 0) {
            let regexData = this.arrayholder[0];

            if (regexData.password_validation_regexp) {
              this.passwordReg = new RegExp(
                regexData.password_validation_regexp
              );
            }

            if (regexData.password_validation_rules) {
              this.setState({
                passwordHelperText: regexData.password_validation_rules,
              });
            }

            if (regexData.email_validation_regexp) {
              this.emailReg = new RegExp(regexData.email_validation_regexp);
            }
          }
        } else if (apiRequestCallId === this.createAccountApiCallId) {
          if (!responseJson.errors) {
            const msg: Message = new Message(
              getName(MessageEnum.AccoutResgistrationSuccess)
            );

            msg.addData(
              getName(MessageEnum.NavigationPropsMessage),
              this.props
            );

            this.send(msg);
          } else {
            //Check Error Response
            this.parseApiErrorResponse(responseJson);
          }

          this.parseApiCatchErrorResponse(errorReponse);
        } else if (apiRequestCallId === this.createUserAccountApiCallId) {
          this.handleCreateUserAccountResponse(responseJson);
        } else if (apiRequestCallId === this.verifyPhoneOtpApiCallId) {
          this.handleVerifyOtpResponse(responseJson);
        } else if (apiRequestCallId === this.sendPhoneOtpApiCallId) {
          if ("message" in responseJson) {
            this.setState({ triggerModal: true });
          } else {
            if (this.formikRef.current) {
              this.formikRef.current.setFieldError(
                "phone",
                responseJson?.error || "Something went wrong!"
              );
            }
          }
          this.setState({ isLoading: false });
        } else if (apiRequestCallId === this.emailVerificationLinkApiCallId) {
          this.handleEmailVerificationApiResponse(responseJson);
        }
      }
    }

    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const otpAuthTkn = message.getData(
        getName(MessageEnum.AuthTokenDataMessage)
      );
      if (otpAuthTkn && otpAuthTkn.length > 0) {
        this.setState({ otpAuthToken: otpAuthTkn });
        runEngine.debugLog("otpAuthTkn", this.state.otpAuthToken);
        runEngine.unSubscribeFromMessages(this as IBlock, [message.id]);
      }
    }

    if (getName(MessageEnum.CountryCodeMessage) === message.id) {
      var selectedCode = message.getData(
        getName(MessageEnum.CountyCodeDataMessage)
      );

      if (selectedCode !== undefined) {
        this.setState({
          countryCodeSelected:
            selectedCode.indexOf("+") > 0
              ? selectedCode.split("+")[1]
              : selectedCode,
        });
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount(): Promise<void> {
    const isLoggedIn = await getStorageData(configJSON.TOKEN);
    if (!!isLoggedIn) {
      this.handlePageRedirection("Home");
    }
  }
  goToPrivacyPolicy() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationPrivacyPolicyMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  goToTermsAndCondition() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationTermAndConditionMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  handlePageRedirection = (path: string) => {
    const navigation = new Message(getName(MessageEnum.NavigationMessage));
    navigation.addData(getName(MessageEnum.NavigationTargetMessage), path);
    navigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigation);
  };

  handleContactUsRedirect = () => {
    this.handlePageRedirection("Contactus");
  };

  handleTermsAndConditionClick = () => {
    logEvent('button_click', { button_name: 'Terms and Conditions' })
  };

  isStringNullOrBlank(str: string) {
    return str === null || str.length === 0;
  }

  isValidEmail(email: string) {
    return this.emailReg.test(email);
  }

  createAccount(): boolean {
    if (
      this.isStringNullOrBlank(this.state.firstName) ||
      this.isStringNullOrBlank(this.state.lastName) ||
      this.isStringNullOrBlank(this.state.email) ||
      this.isStringNullOrBlank(this.state.password) ||
      this.isStringNullOrBlank(this.state.reTypePassword)
    ) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorAllFieldsAreMandatory
      );
      return false;
    }

    var phoneNumberError = this.validateCountryCodeAndPhoneNumber(
      this.state.countryCodeSelected,
      this.state.phone
    );

    if (phoneNumberError) {
      this.showAlert(configJSON.errorTitle, phoneNumberError);
      return false;
    }

    if (!this.isValidEmail(this.state.email)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorEmailNotValid);
      return false;
    }

    if (!this.passwordReg.test(this.state.password)) {
      this.showAlert(configJSON.errorTitle, configJSON.errorPasswordNotValid);
      return false;
    }

    if (this.state.password !== this.state.reTypePassword) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorBothPasswordsNotSame
      );
      return false;
    }

    const header = {
      "Content-Type": configJSON.contentTypeApiAddDetail,
    };

    const attrs = {
      first_name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.email,
      password: this.state.password,
      full_phone_number:
        "+" + this.state.countryCodeSelected + this.state.phone,
    };

    const data = {
      type: "email_account",
      attributes: attrs,
    };

    const httpBody = {
      data: data,
      token: this.state.otpAuthToken,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.createAccountApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.accountsAPiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeAddDetail
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  }

  getValidations() {
    const headers = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const getValidationsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.validationApiCallId = getValidationsMsg.messageId;

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetValidations
    );

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
    runEngine.sendMessage(getValidationsMsg.id, getValidationsMsg);
  }

  isNonNullAndEmpty(value: String) {
    return (
      value !== undefined &&
      value !== null &&
      value !== "null" &&
      value.trim().length > 0
    );
  }

  validateCountryCodeAndPhoneNumber(countryCode: string, phoneNumber: string) {
    let error = null;

    if (this.isNonNullAndEmpty(phoneNumber)) {
      if (!this.isNonNullAndEmpty(String(countryCode))) {
        error = configJSON.errorCountryCodeNotSelected;
      }
    } else if (this.isNonNullAndEmpty(countryCode)) {
      if (!this.isNonNullAndEmpty(phoneNumber)) {
        error = "Phone " + configJSON.errorBlankField;
      }
    }

    return error;
  }

  imgEnableRePasswordFieldProps = {
    source: imgPasswordVisible,
  };

  btnConfirmPasswordShowHideProps = {
    onPress: () => {
      this.setState({
        enableReTypePasswordField: !this.state.enableReTypePasswordField,
      });
      this.txtInputConfirmPasswordProps.secureTextEntry =
        !this.state.enableReTypePasswordField;
      this.imgEnableRePasswordFieldProps.source = this
        .txtInputConfirmPasswordProps.secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  imgEnablePasswordFieldProps = {
    source: imgPasswordVisible,
  };

  btnPasswordShowHideProps = {
    onPress: () => {
      this.setState({ enablePasswordField: !this.state.enablePasswordField });
      this.txtInputPasswordProps.secureTextEntry =
        !this.state.enablePasswordField;
      this.imgEnablePasswordFieldProps.source = this.txtInputPasswordProps
        .secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  btnSignUpProps = {
    onPress: () => this.createAccount(),
  };

  btnLegalPrivacyPolicyProps = {
    onPress: () => this.goToPrivacyPolicy(),
  };

  btnLegalTermsAndConditionProps = {
    onPress: () => this.goToTermsAndCondition(),
  };

  txtInputEmailWebPrpos = {
    onChangeText: (text: string) => {
      this.setState({ email: text });
      //@ts-ignore
      this.txtInputEmailPrpos.value = text;
    },
  };

  txtInputEmailMobilePrpos = {
    ...this.txtInputEmailWebPrpos,
    keyboardType: "email-address",
  };

  txtInputEmailPrpos = this.isPlatformWeb()
    ? this.txtInputEmailWebPrpos
    : this.txtInputEmailMobilePrpos;

  txtPhoneNumberWebProps = {
    onChangeText: (text: string) => {
      this.setState({ phone: text });

      //@ts-ignore
      this.txtPhoneNumberProps.value = text;
    },
  };

  txtPhoneNumberMobileProps = {
    ...this.txtPhoneNumberWebProps,
    autoCompleteType: "tel",
    keyboardType: "phone-pad",
  };

  txtPhoneNumberProps = this.isPlatformWeb()
    ? this.txtPhoneNumberWebProps
    : this.txtPhoneNumberMobileProps;

  txtInputLastNamePrpos = {
    onChangeText: (text: string) => {
      this.setState({ lastName: text });

      //@ts-ignore
      this.txtInputLastNamePrpos.value = text;
    },
  };

  txtInputFirstNamePrpos = {
    onChangeText: (text: string) => {
      this.setState({ firstName: text });

      //@ts-ignore
      this.txtInputFirstNamePrpos.value = text;
    },
  };

  txtInputConfirmPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ reTypePassword: text });

      //@ts-ignore
      this.txtInputConfirmPasswordProps.value = text;
    },
    secureTextEntry: true,
  };

  txtInputPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ password: text });

      //@ts-ignore
      this.txtInputPasswordProps.value = text;
    },
    secureTextEntry: true,
  };

  handleSubmit = (values: ISignUpValues) => {
    const { firstName, lastName, phone, email, password, role } = values;

    const userDetails = {
      first_name: firstName,
      last_name: lastName,
      full_phone_number: phone,
      email: email.trim(),
      terms_accepted: true,
      password,
      password_confirmation: password,
      roles: role,
    };
    this.createUserAccount(userDetails);
  };

  createUserAccount = (userDetails: ISignUpPayload) => {
    this.setState({ isLoading: true, apiError: "" });
    const httpBody = {
      account: userDetails,
    };

    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.createUserAccountApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createUserAccountApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  sendPhoneOtpApi = (phoneNumber: string) => {
    this.setState({ isLoading: true });
    const httpBody = {
      full_phone_number: phoneNumber,
    };

    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.sendPhoneOtpApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.sendPhonOtpApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  submitPhoneOtpApi = (phoneVerificationDetails: IPhoneVerificationValues) => {
    this.setState({ isVerifyingPhone: true });
    const httpBody = { ...phoneVerificationDetails };

    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.verifyPhoneOtpApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.verifyPhonOtpApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  emailVerificationLinkApi = () => {
    this.setState({ isLoading: true });
    const httpBody = {
      email: this.state.createdAccountEmail,
    };

    const header = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.emailVerificationLinkApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.emailVerificationLinkApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPostMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
    return true;
  };

  handleResendEmailDialogOpen = (
    infoType: "success" | "error",
    infoMessage: string
  ) => {
    this.setState({
      isResendEmailDialog: true,
      resendEmailInfoType: infoType,
      resendEmailMessage: infoMessage,
      isLoading: false,
    });
  };

  handleResendEmailDialogClose = () => {
    this.setState({ isResendEmailDialog: false });
  };

  handleCreateUserAccountResponse = (
    responseJson:
      | ISignUpSuccessResponse
      | ISignUpErrorResponse
      | ISignUpErrorsResponse
  ) => {
    if ("errors" in responseJson || "error" in responseJson) {
      if ("errors" in responseJson) {
        if (this.formikRef.current) {
          const errorKeys: Record<string, string> = {
            email: "email",
            full_phone_number: "phone",
          };
          const { errors } = responseJson;
          const { setErrors } = this.formikRef.current;
          let displayErrors: FormikErrors<ISignUpValues> = {};
          errors.forEach((errorObj) => {
            const field = Object.keys(errorObj)[0];
            const message = errorObj[field];

            if (field && message) {
              displayErrors[errorKeys[field] as keyof ISignUpValues] = message;
            }
          });
          setErrors(displayErrors);
          this.setState({ isLoading: false });
        }
      }

      if ("error" in responseJson && typeof responseJson.error === "string") {
        this.setState({
          apiError: "Oops! Something went wrong. Please try again in a moment.",
          isLoading: false,
        });
      }
    } else {
      logEvent("sign_up", { method: "email" });
      const {
        values: { email },
      } = this.formikRef.current || { values: { email: "" } };
      this.setState({
        isAccountDetailsFilled: true,
        isLoading: false,
        createdAccountEmail: email,
      });
    }
  };

  handleVerifyOtpResponse = (
    responseJson:
      | IPhoneVerificationSuccessResponse
      | IPhoneVerificationErrorResponse
  ) => {
    if ("message" in responseJson) {
      this.setState({ isPhoneVerified: true, isVerifyingPhone: false });
      this.handleCloseOtpModal();
    } else {
      this.setState({ otpError: responseJson.error, isVerifyingPhone: false });
    }
  };

  handleEmailVerificationApiResponse = (
    responseJson:
      | IEmailVerificationSuccessResponse
      | IEmailVerificationErrorResponse
  ) => {
    if ("message" in responseJson) {
      this.handleResendEmailDialogOpen("success", responseJson.message);
    } else {
      this.handleResendEmailDialogOpen("error", "");
    }
  };

  handleCloseOtpModal = () => {
    this.setState({
      triggerModal: false,
      verifyPhoneOtp: ["", "", "", ""],
    });
  };

  handleSendOtp = () => {
    if (this.formikRef.current) {
      const {
        values: { phone },
      } = this.formikRef.current;
      this.sendPhoneOtpApi(phone);
    }
  };

  handleVerifyBtnClick = () => {
    this.handleSendOtp();
  };

  handleSubmitOtp = () => {
    if (this.formikRef.current) {
      const {
        values: { phone },
      } = this.formikRef.current;
      const { verifyPhoneOtp } = this.state;
      const phoneVerificationDetails = {
        phone_number: phone,
        pin: verifyPhoneOtp.join(""),
      };
      this.submitPhoneOtpApi(phoneVerificationDetails);
    }
  };

  setFirstName = (text: string) => {
    this.setState({ firstName: text });
  };

  setLastName = (text: string) => {
    this.setState({ lastName: text });
  };

  setEmail = (text: string) => {
    this.setState({ email: text });
  };

  setPhoneNumber = (text: string) => {
    this.setState({ phone: text, isPhoneVerified: false });
  };

  handlePassword = () => {
    this.setState({
      enablePasswordField: !this.state.enablePasswordField,
    });
  };

  handleReTypePassword = () => {
    this.setState({
      enableReTypePasswordField: !this.state.enableReTypePasswordField,
    });
  };

  handleNavigation = (path: string) => {
    logEvent('button_click', { button_name: path })
    this.props.navigation.navigate(path);
  };

  handleOtpChange = (index: number, event: React.ChangeEvent) => {
    const inputEvent = event as React.ChangeEvent<HTMLInputElement>;
    const { value } = inputEvent.target;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...this.state.verifyPhoneOtp];
    newOtp[index] = value;
    this.setState({ verifyPhoneOtp: newOtp });

    if (value && index < 3) {
      this.inputRefs[index + 1].current?.focus();
    }
  };

  handleOtpKeyDown = (index: number, event: React.KeyboardEvent) => {
    const inputEvent = event as React.KeyboardEvent<HTMLInputElement>;
    if (inputEvent.key === "Backspace") {
      const newOtp = [...this.state.verifyPhoneOtp];
      if (newOtp[index]) {
        newOtp[index] = "";
      } else if (index > 0) {
        newOtp[index - 1] = "";
        this.inputRefs[index - 1].current?.focus();
      }
      this.setState({ verifyPhoneOtp: newOtp, otpError: "" });
    }
  };

  getSignUpCompletedMessage = () => {
    const { createdAccountEmail } = this.state;
    return `${configJSON.signUpCompleteDescriptionFirst}${createdAccountEmail}${configJSON.signUpCompleteDescriptionSecond}`;
  };
  // Customizable Area End
}
